import { useState } from "react";
import { toast } from "react-toastify";
import { useExportCollars } from "./useExportCollars";
import { useExportCameraTraps } from "./useExportCameraTraps";

export function useExportDevices() {
  const [isLoading, setIsLoading] = useState(false);
  const collars = useExportCollars();
  const cameraTraps = useExportCameraTraps();

  const handleExport = async () => {
    setIsLoading(true);

    try {
      const results = await Promise.allSettled([
        collars.handleExport(),
        cameraTraps.handleExport(),
      ]);

      const collarsSuccess = results[0].status === "fulfilled";
      const cameraTrapsSuccess = results[1].status === "fulfilled";

      if (!collarsSuccess && !cameraTrapsSuccess) {
        toast.error("Erro ao exportar relatórios de equipamentos");
        return;
      }
    } catch {
      toast.error("Erro ao exportar relatórios de equipamentos");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
